import { PropertySection, SwitchPropertyHandler } from "@glide/function-utils";

export const autofocusPropertyHandler = new SwitchPropertyHandler(
    { autofocus: false },
    "Autofocus",
    PropertySection.Options
);
